import type { MouseEventHandler } from "react";
import { Check, Copy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function GatewayRegistrationCode({ registrationToken, expiresAt, copied, onCopy }: {
  registrationToken: string;
  expiresAt: string;
  copied: boolean;
  onCopy: MouseEventHandler<HTMLButtonElement>;
}) {
  const { t } = useTranslation("storages");
  return (
      <dl className="mt-4 grid gap-4 sm:grid-cols-2">
        <div className="space-y-1">
          <dt className="text-sm text-muted-foreground">
            {t("detail.localGatewaySetupToken")}
          </dt>
          <div className="flex min-w-0 items-center gap-2">
            <dd className="min-w-0 break-all font-mono text-sm font-semibold text-slate-950">
              {registrationToken}
            </dd>
            <TooltipProvider delayDuration={150}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 shrink-0"
                    aria-label={
                      copied
                        ? t("detail.localGatewaySetupCopied")
                        : t("detail.localGatewaySetupCopyToken")
                    }
                    onClick={onCopy}
                  >
                    {copied ? <Check className="h-4 w-4" aria-hidden="true" /> : <Copy className="h-4 w-4" aria-hidden="true" />}
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  {copied ? t("detail.localGatewaySetupCopied") : t("detail.localGatewaySetupCopyToken")}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
        <div className="space-y-1">
          <dt className="text-sm text-muted-foreground">
            {t("detail.localGatewaySetupExpiresAt")}
          </dt>
          <dd className="text-sm font-medium text-slate-950">
            {new Date(expiresAt).toLocaleString("ja-JP")}
          </dd>
        </div>
      </dl>
  );
}
